<div class="header">
  <h3>Admin</h3>
</div>
<div class="row">
  <div class="col tab-menu">
    <admin-nav-menu [currentTab]="'business-lines'"></admin-nav-menu>
  </div>

  <div class="col col-constrained">
    <fieldset>
      <legend>Business Lines</legend>
      <div class="form-group">
        <label for="new-business-line">Add new business line?</label>
        <input type="text"
          id="new-business-line"
          [(ngModel)]="newBusinessLineName"
          (keypress)="$event.keyCode == 13 ? createBusinessLine() : null"
          class="form-control editor-lg"
          placeholder="Enter new business line name" />
        </div>
        <button type="button" class="btn btn-primary" (click)="createBusinessLine()">
          <i class="fa fa-save"></i>
          Save
        </button>
        <table class="table table-sm table-align-middle my-3">
          <thead>
            <tr>
              <th class="col-action"></th>
              <th class="col-action"></th>
              <th style="width: 1rem;">Id</th>
              <th>Name</th>
            </tr>
          </thead>
          <tbody>
            @if (activeBusinessLines.length == 0) {
              <tr>
                <td colspan="4">
                  <span class="d-block p-2 text-center">
                    <i class="fa fa-ban text-danger"></i>
                    No data to display&hellip;
                  </span>
                </td>
              </tr>
            }
            @for (businessLine of activeBusinessLines; track businessLine; let i = $index) {
              <tr>
                <td class="text-center">
                  <button [disabled]="businessLine.engagements.length > 0 || businessLine.inspectionProfiles.length > 0"
                    type="button"
                    class="btn btn-sm btn-secondary"
                    (click)="destroyBusinessLine(businessLine)">
                    <i class="fa fa-trash"></i>
                    <span class="sr-only">Remove</span>
                  </button>
                </td>
                <td>
                  <button type="button"
                    class="btn btn-sm btn-primary"
                    (click)="updateBusinessLine(businessLine)">
                    <i class="fa fa-save"></i>
                    <span class="sr-only">Save</span>
                  </button>
                </td>
                <td class="px-3 font-weight-bold">{{businessLine.id}}</td>
                <td>
                  <input type="text" class="form-control form-control-sm editor-lg d-inline-block mr-2" name="business-line-{{i}}" [(ngModel)]="businessLine.name" required />
                  <small class="form-text validation-message">Name is required.</small>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </fieldset>
    </div>
  </div>
